module.exports = __webpack_public_path__ + "img/bg03.19e42a0a.jpg";